import React from "react";
import { BaseListItemIcon } from "./style";
import PropTypes from "prop-types";
import Icon from "components/common/Icon";
import styled from "styled-components";
import { SIZE } from "constant";

ListItemIcon.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  iconSize: PropTypes.oneOf([
    SIZE.xxs,
    SIZE.xs,
    SIZE.small,
    SIZE.medium,
    SIZE.large,
    SIZE.xl,
    SIZE.xxl,
    SIZE._3xl,
    SIZE._4xl,
    SIZE._4xlh,
    SIZE._5xl,
    SIZE._6xl,
    SIZE._7xl,
  ]),
};
ListItemIcon.defaultProps = {
  name: null,
  color: null,
  iconSize: SIZE.small,
};

export default function ListItemIcon(props) {
  let cursor = "inherit";
  if (props.onClick) {
    cursor = "pointer";
  }

  const emptyIconSize = () => {
    switch (props.iconSize) {
      case SIZE.xxs:
        return 10;
      case SIZE.xs:
        return 12;
      case SIZE.small:
        return 14;
      case SIZE.medium:
        return 15;
      case SIZE.large:
        return 16;
      case SIZE.xl:
        return 18;
      case SIZE.xxl:
        return 20;
      case SIZE._3xl:
        return 24;
      case SIZE._4xl:
        return 28;
      case SIZE._4xlh:
        return 28;
      case SIZE._5xl:
        return 32;
      case SIZE._6xl:
        return 40;
      case SIZE._7xl:
        return 48;
      default:
        return 15;
    }
  };

  const handleOnClick = (event) => {
    if (props.onClick) {
      props.onClick(event);
    }
  };

  if (props.name) {
    return (
      <BaseListItemIcon cursor={cursor}>
        <Icon
          name={props.name}
          color={props.color}
          size={props.iconSize}
          onClick={(event) => handleOnClick(event)}
        ></Icon>
      </BaseListItemIcon>
    );
  } else {
    return (
      <BaseListItemIcon>
        <EmptyIcon size={emptyIconSize()}></EmptyIcon>
      </BaseListItemIcon>
    );
  }
}

const EmptyIcon = styled.div`
width: ${(props) => props.size}px
height: ${(props) => props.size}px
`;
